// 小组与学员
import { sendLogById, sendLogClick } from './index'

export default {
  // 页面初始化
  initPageLogger(data) {
    sendLogById('smallfox-teacher_30', {
      ...data
    })
  },
  // 小组与学员——【查看学习详情】（点击学员姓名按钮）
  clickStuLogger(data) {
    sendLogClick('smallfox-teacher_27', {
      ...data
    })
  },
  // 小组与学员——【学习报告】按钮
  reportLogger(data) {
    sendLogClick('smallfox-teacher_26', {
      ...data
    })
  },
  // 小组与学员——创建小组
  addGroupLogger(data) {
    sendLogClick('smallfox-teacher_3', {
      ...data
    })
  }
}